import { configureStore } from '@reduxjs/toolkit';
import envsReducer from './slices/envsSlice';
import spinnerReducer from './slices/spinnerSlice';
import snackbarReducer from './slices/snackbarSlice';
import notificationsReducer from './slices/notificationsSlice';
import alertDialogReducer from './slices/alertDialogSlice';

export const store = configureStore({
  reducer: {
    envs: envsReducer,
    spinner: spinnerReducer,
    snackbar: snackbarReducer,
    notifications: notificationsReducer,
    alertDialog: alertDialogReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
